import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.0.0-rc.0_@babel+core@7.24.7_react-dom@19.0.0-rc-6f23540c7d-20240528_react@19.0.0-rc-6_37u3gk7qe5eiavh2ve2nam5afq/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/_components/lang-swithcher.tsx");
